module.exports = __webpack_public_path__ + "7f7f4d4158565dba34112a765509a97d.svg";